var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticStyle: { "font-size": "14px", "font-weight": "bold" } }, [
      _vm._v("Material Type" + _vm._s(_vm.rightFlag) + "：")
    ]),
    _c("div", { staticClass: "temperature" }, [
      _c(
        "div",
        { staticClass: "mt-4 van-row flex" },
        [
          _c(
            "van-radio-group",
            {
              attrs: { direction: "horizontal" },
              on: { change: _vm.onMaterialChange },
              model: {
                value: _vm.value.materialType2,
                callback: function($$v) {
                  _vm.$set(_vm.value, "materialType2", $$v)
                },
                expression: "value.materialType2"
              }
            },
            [
              _c(
                "van-radio",
                { attrs: { name: 1, "checked-color": "#8866f5" } },
                [_vm._v("SS316")]
              ),
              _c(
                "van-radio",
                { attrs: { name: 2, "checked-color": "#8866f5" } },
                [_vm._v("SS904")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showBaseR
        ? _c("div", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v("Base R1 = " + _vm._s(_vm.doubleR1) + "Ω")
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "temperature-container" },
        [
          _c(
            "van-row",
            { attrs: { align: "center" } },
            [
              _c("van-col", { attrs: { span: "12" } }, [
                _c(
                  "div",
                  { staticClass: "flex-col-center" },
                  [
                    _c("div", [_vm._v("Temperature")]),
                    _c("van-stepper", {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { step: "10", min: "0", max: "1000" },
                      on: {
                        change: function($event) {
                          return _vm.onTemperateChange("t")
                        }
                      },
                      model: {
                        value: _vm.value.temperature2,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "temperature2", $$v)
                        },
                        expression: "value.temperature2"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("van-col", { attrs: { span: "12" } }, [
                _c("div", { staticClass: "flex-col-center" }, [
                  _c("div", [_vm._v("Push Power(W)")]),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.value.pushPower2,
                          expression: "value.pushPower2",
                          modifiers: { number: true }
                        }
                      ],
                      staticStyle: { width: "100px", "text-align": "center" },
                      domProps: { value: _vm.value.pushPower2 },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.value,
                              "pushPower2",
                              _vm._n($event.target.value)
                            )
                          },
                          function($event) {
                            return _vm.onTemperateChange("p1")
                          }
                        ],
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ])
                ])
              ])
            ],
            1
          ),
          false
            ? _c(
                "van-row",
                {
                  staticStyle: { "margin-top": "16px" },
                  attrs: { align: "center" }
                },
                [
                  _c("van-col", { attrs: { span: "12" } }, [
                    _c("div", { staticClass: "flex-col-center" }, [
                      _c("div", [_vm._v("Proportion")]),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.value.proportion2,
                              expression: "value.proportion2",
                              modifiers: { number: true }
                            }
                          ],
                          staticStyle: {
                            width: "100px",
                            "text-align": "center"
                          },
                          domProps: { value: _vm.value.proportion2 },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "proportion2",
                                  _vm._n($event.target.value)
                                )
                              },
                              function($event) {
                                return _vm.onTemperateChange("p2")
                              }
                            ],
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _c("van-col", { attrs: { span: "12" } }, [
                    _c("div", { staticClass: "flex-col-center" }, [
                      _c("div", [_vm._v("Integral")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.value.integral2,
                            expression: "value.integral2",
                            modifiers: { number: true }
                          }
                        ],
                        staticStyle: { width: "100px", "text-align": "center" },
                        domProps: { value: _vm.value.integral2 },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.value,
                                "integral2",
                                _vm._n($event.target.value)
                              )
                            },
                            function($event) {
                              return _vm.onTemperateChange("i")
                            }
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }